import { Link, useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { scrollToSection } from "../lib/scroll";

const PAGE_LINKS = [
  { label: "Home", id: "home" },
  { label: "How It Works", id: "how-it-works" },
  { label: "Features", id: "features" },
  { label: "FAQ", id: "faq" },
];

export default function Footer({ onLegal }) {
  const navigate = useNavigate();
  const onAppView = window.location.hash.startsWith("#/app");

  const goPage = (id) => {
    if (onAppView) {
      navigate("/");
      setTimeout(() => scrollToSection(id), 400);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="border-t border-white/[0.06] bg-navy-900/60"
    >
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.3fr_0.8fr_0.8fr_1fr]">
        <div>
          <Logo onClick={() => goPage("home")} />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            Fast &amp; Simple USDT to INR Exchange
          </p>
        </div>

        <div data-testid="footer-pages">
          <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Pages
          </h3>
          <ul className="mt-5 space-y-3">
            {PAGE_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => goPage(l.id)}
                  className="text-sm text-slate-300 transition-colors hover:text-emerald-300"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div data-testid="footer-account">
          <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Account
          </h3>
          <ul className="mt-5 space-y-3">
            <li>
              <Link
                data-testid="footer-login"
                to="/app"
                className="text-sm text-slate-300 transition-colors hover:text-emerald-300"
              >
                Login
              </Link>
            </li>
            <li>
              <Link
                data-testid="footer-create-order"
                to="/app"
                className="inline-flex items-center gap-1.5 text-sm text-slate-300 transition-colors hover:text-emerald-300"
              >
                Create Order
                <ArrowUpRight className="h-3.5 w-3.5" />
              </Link>
            </li>
          </ul>
        </div>

        <div data-testid="footer-contact">
          <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
            Contact &amp; Legal
          </h3>
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Support is available inside your CDM Pay account after login.
          </p>
          <ul className="mt-4 space-y-3">
            <li>
              <button
                data-testid="footer-terms"
                onClick={() => onLegal("terms")}
                className="text-sm text-slate-300 transition-colors hover:text-emerald-300"
              >
                Terms &amp; Conditions
              </button>
            </li>
            <li>
              <button
                data-testid="footer-privacy"
                onClick={() => onLegal("privacy")}
                className="text-sm text-slate-300 transition-colors hover:text-emerald-300"
              >
                Privacy Policy
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="container-x flex flex-col gap-3 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500" data-testid="footer-disclaimer">
            Rates, processing times and payment availability may vary depending on
            the applicable order conditions.
          </p>
          <p className="text-xs text-slate-600">
            © {new Date().getFullYear()} CDM Pay. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
